import React, { Component } from "react";
import { format, sub } from "date-fns";
import { hu } from "date-fns/locale";
import "./reset.css";
import "./App.css";
import MarketList from "./components/MarketList";
import ProductList from "./components/ProductList";
import Loading from "./components/Loading";
import ErrorMessage from "./components/ErrorMessage";
import Chart from "./components/Chart";

const styles = {
  marketRates: {
    minHeight: 300,
  },
  marketListContainer: {
    position: "relative",
    height: "100%",
    minHeight: 300,
  },
};

class App extends Component {
  state = {
    markets: [],
    market: {
      products: [],
    },
    isLoading: true,
    isChartLoading: true,
    isError: false,
    chartData: [],
    dates: [
      false,
      format(sub(new Date(), { years: 1 }), "yyyy-MM-dd"),
      format(sub(new Date(), { months: 6 }), "yyyy-MM-dd"),
      format(sub(new Date(), { months: 3 }), "yyyy-MM-dd"),
      format(sub(new Date(), { months: 1 }), "yyyy-MM-dd"),
    ],
    selectedDateIndex: 2,
    selectedMarket: {},
    title: "",
    chartData: [],
    selectedCurrency: "EUR",
    marketName: "Euronext",
    isChartOpen: false,
  };

  toggleChart = () => {
    this.setState({ isChartOpen: !this.state.isChartOpen });
  };

  setSelectedDate = (event) => {
    this.setState(
      {
        selectedDateIndex: parseInt(event.target.value),
      },
      () => this.getRates(event, this.state.selectedDeadLine)
    );
  };

  getMarkets = () => {
    fetch(`${process.env.REACT_APP_API_URL}/markets`)
      .then((response) => response.json())
      .then((data) => this.setState({ markets: data.markets }))
      .catch(() => this.setState({ isError: true }));
  };

  getMarket = (market = "EURONEXT") => {
    this.setState({ isLoading: true, isError: false }, () => {
      fetch(`${process.env.REACT_APP_API_URL}/markets/${market}`)
        .then((response) => response.json())
        .then((data) => this.setState({ market: data.market }))
        .catch(() => this.setState({ isError: true }))
        .finally(() => this.setState({ isLoading: false }));
    });
  };

  getRates = (event, deadline) => {
    event.stopPropagation();

    this.setState({
      isChartLoading: true,
      isChartOpen: true,
      selectedDeadLine: deadline,
    });

    return fetch(
      `${process.env.REACT_APP_API_URL}/rates/${deadline.id}?from=${
        this.state.dates[this.state.selectedDateIndex]
      }`
    )
      .then((response) => response.json())
      .then((data) => {
        const dates = Object.keys(data.rates);
        dates.sort((dateA, dateB) => dateA > dateB);

        if (data && dates.length) {
          const first = data.rates[dates[0]];
          this.setState({
            title: `${first.product.name} (${first.market.city}) ${format(
              new Date(data.deadline.date),
              "yyyy MMMM",
              { locale: hu }
            )}`,
          });

          const formattedRates = Object.values(data.rates).map((rate) => {
            const value =
              this.state.market.name === "CBOT" ? rate.usd : rate.eur;

            return {
              value,
              product: data.deadline.product_id,
              rate: rate.current,
            };
          });

          this.setState({
            chartData: formattedRates.map(({ value, rate }) => ({
              date: rate,
              ár: value,
            })),
          });
        }
      })
      .catch((error) => {
        console.log(error);
        /*  setIsError(true); */
      })
      .finally(() => {
        this.setState({ isChartLoading: false });
      });
  };

  componentDidMount() {
    Promise.all([this.getMarkets(), this.getMarket()]);
  }

  render() {
    const {
      markets,
      market,
      title,
      isLoading,
      isChartLoading,
      isError,
      chartData,
      isChartOpen,
      selectedCurrency,
      selectedDeadLine,
      selectedDateIndex,
    } = this.state;

    return (
      <>
        <div style={styles.marketRates} className="market-component">
          {isChartOpen ? (
            <Chart
              title={title}
              market={market}
              data={chartData}
              isLoading={isChartLoading}
              currency={selectedCurrency}
              deadline={selectedDeadLine}
              closeChart={this.toggleChart}
              setSelectedDate={this.setSelectedDate}
              selectedDateIndex={selectedDateIndex}
            />
          ) : (
            ""
          )}
          <div style={styles.marketListContainer}>
            <MarketList
              markets={markets}
              selectedMarket={market.name}
              getMarket={this.getMarket}
            />
            {isLoading ? (
              <Loading />
            ) : (
              <ProductList market={market} getRates={this.getRates} />
            )}
          </div>
          {isError ? (
            <ErrorMessage message={"Hiba történt az adatok lekérése során."} />
          ) : (
            <div></div>
          )}
        </div>
        <p className="market-component-placeholder">
          A mobilnézet nem támogatott, kérjük töltse le az Agrimarket
          applikációt.
        </p>
      </>
    );
  }
}

export default App;
